import { render, staticRenderFns } from "./OptionSelect.vue?vue&type=template&id=63496c5d&scoped=true"
import script from "./OptionSelect.vue?vue&type=script&lang=js"
export * from "./OptionSelect.vue?vue&type=script&lang=js"
import style0 from "./OptionSelect.vue?vue&type=style&index=0&id=63496c5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63496c5d",
  null
  
)

export default component.exports